import en from "./translations/en.json";
import type { Locale } from "@procore/globalization-toolkit";
import { getFallbackLocaleList } from "@procore/globalization-toolkit";
import deDE from "./translations/de-DE.json";
import enAU from "./translations/en-AU.json";
import enCA from "./translations/en-CA.json";
import enGB from "./translations/en-GB.json";
import esES from "./translations/es-ES.json";
import es from "./translations/es.json";
import frCA from "./translations/fr-CA.json";
import frFR from "./translations/fr-FR.json";
import isIS from "./translations/is-IS.json";
import jaJP from "./translations/ja-JP.json";
import plPL from "./translations/pl-PL.json";
import ptBR from "./translations/pt-BR.json";
import thTH from "./translations/th-TH.json";
import zhSG from "./translations/zh-SG.json";

const supportedLocales: any = {
   "de-DE": deDE,
   "en-AU": enAU,
   "en-CA": enCA,
   "en-GB": enGB,
   en,
   "es-ES": esES,
   es,
   "fr-CA": frCA,
   "fr-FR": frFR,
   "is-IS": isIS,
   "ja-JP": jaJP,
   "pl-PL": plPL,
   pseudo: en,
   "pt-BR": ptBR,
   "th-TH": thTH,
   "zh-SG": zhSG,
};

// Define a type that can handle nested structures
type DeepNestedRecords = {
   [key: string]: string | DeepNestedRecords;
};
export function getTranslations(envLocale: Locale): Record<string, DeepNestedRecords> {
   return Object.fromEntries(
      getFallbackLocaleList(envLocale).map((locale) => [locale, supportedLocales[locale] ?? {}]),
   );
}
